import { render, staticRenderFns } from "./CarouselVcDemo.vue?vue&type=template&id=225acfdb&scoped=true&"
import script from "./CarouselVcDemo.vue?vue&type=script&lang=js&"
export * from "./CarouselVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./CarouselVcDemo.vue?vue&type=style&index=0&id=225acfdb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225acfdb",
  null
  
)

export default component.exports